import React from 'react';
import ArticleContainer from '@src/containers/Article';

const Article = () => <ArticleContainer />;

export default Article;
